import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link as GatsbyLink } from 'gatsby';

export const isExternalLink = (url) => url?.includes('//');

const StyledLink = styled.a`
  color: ${({ $onDark, theme }) =>
    $onDark ? theme.global.colors['light-1'] : theme.global.colors.brand};

  position: relative;
  transition: all 0.3s ease;
  text-decoration: none;
  @media (hover: hover) {
    &:hover {
      color: ${({ $onDark }) => ($onDark ? 'inherit' : 'black')};
    }
  }
  p > & {
    color: ${({ theme }) => theme.global.colors.brand};
  }
`;

const Link = ({ children, href, className, onDark }) => {
  // Internal link
  return (
    <StyledLink
      $onDark={onDark}
      className={className}
      as={GatsbyLink}
      to={href}
    >
      {children}
    </StyledLink>
  );
};

Link.defaultProps = {
  onDark: false,
};

Link.propTypes = {
  onDark: PropTypes.bool,
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
};

export default Link;
